export const CAMERA_RETRY_DELAY_MS = 300;
export const getVideoErrorMessage = (error: unknown): string => {
  return (error as { reason?: string })?.reason || 'Unable to start video.';
};
export const isCameraStartingError = (
  error: unknown
): error is { errorCode?: number; reason?: string; type?: string } => {
  if (!error || typeof error !== 'object') return false;
  const { errorCode, reason } = error as { errorCode?: number; reason?: string };
  return errorCode === 6105 || !!reason?.includes('Camera is starting');
};
